import { generateBaseLayout } from './baseLayout';

export const generateVerticalLayout = (config) => {
    return generateBaseLayout(config);
}; 